import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './state/index-family.store';
import { ConfigModule } from 'NewAngular/config/config.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { EditDataColumnsModalModule } from 'NewAngular/features/components/modals/edit-data-columns-modal/edit-data-columns-modal.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PaginationControlsModule } from 'NewAngular/features/components/pagination/pagination-controls/pagination-controls.module';
import { SimplePaginationControlsModule } from 'NewAngular/features/components/pagination/simple-pagination-controls/simple-pagination-controls.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { IndexFamilyPageComponent } from 'IndicesApp/ts/apps/index-family-app/components/index-family-page/index-family-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [TopBarNavComponent, IndexFamilyPageComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        // We need a root store (even if it's empty) because the autocompleter in the top bar nav uses NgRx
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
        BaseAutocompleteModule,
        LoadingSymbolModule,
        SimplePaginationControlsModule,
        PaginationControlsModule,
        EditDataColumnsModalModule] });
